import actionTypes from "../constants/actionTypes"

const initialBoardState = {
    loading: false,
    error: null,
    data: {
        content: [],
        totalPages: 0,
        totalElements: 0,
        number: 0,
        size: 10,
    },
}

const initialDetailState = {
    loading: false,
    error: null,
    data: null,
}

const initialWriteState = {
    loading: false,
    error: null,
    success: false,
}

const initialUpdateState = {
    loading: false,
    error: null,
    success: false,
}

const initialDeleteState = {
    loading: false,
    error: null,
    success: false,
}

const initialState = {
    // 메뉴 ID별로 게시판 데이터 관리
    boards: {}, // { menuId: { loading, error, data } }
    // 상세 정보는 전역으로 관리 (한 번에 하나만 보기 때문)
    detail: initialDetailState,
    // 글쓰기 상태도 전역으로 관리
    write: initialWriteState,
    // 수정 상태 관리
    update: initialUpdateState,
    // 삭제 상태 관리
    delete: initialDeleteState,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // ========== 게시판 목록 관련 ==========
        case actionTypes.BOARD_FETCH: {
            const { menuId } = action.payload
            return {
                ...state,
                boards: {
                    ...state.boards,
                    [menuId]: {
                        ...initialBoardState,
                        loading: true,
                        error: null,
                    },
                },
            }
        }
        case actionTypes.BOARD_FETCH_SUCCEED: {
            const { menuId } = action.payload
            return {
                ...state,
                boards: {
                    ...state.boards,
                    [menuId]: {
                        loading: false,
                        data: action.payload,
                        error: null,
                    },
                },
            }
        }
        case actionTypes.BOARD_FETCH_FAILED: {
            const { menuId } = action.payload
            return {
                ...state,
                boards: {
                    ...state.boards,
                    [menuId]: {
                        loading: false,
                        error: action.payload.error,
                        data: initialBoardState.data,
                    },
                },
            }
        }

        // ========== 게시판 상세 관련 ==========
        case actionTypes.BOARD_DETAIL_FETCH:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    loading: true,
                    error: null,
                },
            }
        case actionTypes.BOARD_DETAIL_FETCH_SUCCEED:
            return {
                ...state,
                detail: {
                    loading: false,
                    data: action.payload,
                    error: null,
                },
            }
        case actionTypes.BOARD_DETAIL_FETCH_FAILED:
            return {
                ...state,
                detail: {
                    loading: false,
                    error: action.payload,
                    data: null,
                },
            }
        case actionTypes.BOARD_DETAIL_RESET:
            return {
                ...state,
                detail: initialDetailState,
            }

        // ========== 게시판 작성 관련 ==========
        case actionTypes.BOARD_WRITE:
            return {
                ...state,
                write: {
                    loading: true,
                    error: null,
                    success: false,
                },
            }
        case actionTypes.BOARD_WRITE_SUCCEED:
            return {
                ...state,
                write: {
                    loading: false,
                    error: null,
                    success: true,
                },
            }
        case actionTypes.BOARD_WRITE_FAILED:
            return {
                ...state,
                write: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            }
        case actionTypes.BOARD_WRITE_RESET:
        case "BOARD_WRITE_RESET":
            return {
                ...state,
                write: initialWriteState,
            }

        // ========== 게시판 수정 관련 ==========
        case actionTypes.BOARD_UPDATE:
            return {
                ...state,
                update: {
                    loading: true,
                    error: null,
                    success: false,
                },
            }
        case actionTypes.BOARD_UPDATE_SUCCEED:
            return {
                ...state,
                update: {
                    loading: false,
                    error: null,
                    success: true,
                },
            }
        case actionTypes.BOARD_UPDATE_FAILED:
            return {
                ...state,
                update: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            }
        case actionTypes.BOARD_UPDATE_RESET:
            return {
                ...state,
                update: initialUpdateState,
            }

        // ========== 게시판 삭제 관련 ==========
        case actionTypes.BOARD_DELETE:
            return {
                ...state,
                delete: {
                    loading: true,
                    error: null,
                    success: false,
                },
            }
        case actionTypes.BOARD_DELETE_SUCCEED:
            return {
                ...state,
                delete: {
                    loading: false,
                    error: null,
                    success: true,
                },
            }
        case actionTypes.BOARD_DELETE_FAILED:
            return {
                ...state,
                delete: {
                    loading: false,
                    error: action.payload.error,
                    success: false,
                },
            }

        // ========== 특정 메뉴의 게시판 데이터 초기화 ==========
        case actionTypes.BOARD_RESET: {
            const { menuId } = action.payload
            const newBoards = { ...state.boards }
            delete newBoards[menuId]
            return {
                ...state,
                boards: newBoards,
            }
        }

        default:
            return state
    }
}
